(() => {
  const measurementsDataEl = document.querySelector('[data-product-details-measurements]');
  const measurementsSpecsRoot = document.querySelector('[data-product-details-measurements-specs]');
  let productDetailsMeasurementsData = null;

  if (measurementsDataEl) {
    try {
      productDetailsMeasurementsData = JSON.parse(measurementsDataEl.textContent || '{}');
    } catch (e) {
      productDetailsMeasurementsData = null;
    }
  }

  function getPdpSizeOptionIndex() {
    const pdpRoot = document.querySelector('.pdp-redesign[data-size-option-index]');
    if (!pdpRoot) return -1;
    return parseInt(pdpRoot.getAttribute('data-size-option-index') || '-1', 10);
  }

  function readSelectedSizeValue(variant, sizeIndex) {
    if (sizeIndex < 0) return null;

    const optionKey = `option${sizeIndex + 1}`;
    if (variant && variant[optionKey]) return variant[optionKey];

    const pdpRoot = document.querySelector('.pdp-redesign[data-section-id]');
    if (!pdpRoot) return null;

    const checkedSizeRadio = pdpRoot.querySelector(
      `.SizeSwatch__Radio[data-option-position="${sizeIndex + 1}"]:checked`,
    );
    return checkedSizeRadio ? checkedSizeRadio.value : null;
  }

  function getProductDetailsMeasurementItems(sizeValue) {
    if (!productDetailsMeasurementsData) return [];

    const original = Array.isArray(productDetailsMeasurementsData.original)
      ? productDetailsMeasurementsData.original
      : [];
    const narrow = Array.isArray(productDetailsMeasurementsData.narrow)
      ? productDetailsMeasurementsData.narrow
      : [];

    if (
      !productDetailsMeasurementsData.hasSizeOption ||
      !sizeValue ||
      !String(sizeValue).toLowerCase().includes('narrow')
    ) {
      return original;
    }

    return narrow.length ? narrow : original;
  }

  function renderProductDetailsMeasurements(items) {
    if (!measurementsSpecsRoot) return;

    measurementsSpecsRoot.innerHTML = '';

    items.forEach((item) => {
      const row = document.createElement('div');
      row.className = 'product-details-spec-item';

      const label = document.createElement('div');
      label.className = 'product-details-spec-label';
      label.textContent = item.label != null ? String(item.label) : '';

      const value = document.createElement('div');
      value.className = 'product-details-spec-value';
      value.setAttribute('data-product-details-spec-value', '');
      value.textContent = item.value != null ? String(item.value) : '';

      row.appendChild(label);
      row.appendChild(value);
      measurementsSpecsRoot.appendChild(row);
    });
  }

  function updateProductDetailsMeasurements(sizeValue) {
    if (!measurementsSpecsRoot || !productDetailsMeasurementsData) return;

    const items = getProductDetailsMeasurementItems(sizeValue);
    if (!items.length) return;

    renderProductDetailsMeasurements(items);
  }

  function syncProductDetailsMeasurementsFromVariant(event) {
    const variant = event && event.detail ? event.detail.variant : null;
    const sizeIndex = getPdpSizeOptionIndex();
    updateProductDetailsMeasurements(readSelectedSizeValue(variant, sizeIndex));
  }

  document.addEventListener('variant:changed', syncProductDetailsMeasurementsFromVariant);
  syncProductDetailsMeasurementsFromVariant(null);

  const roots = document.querySelectorAll('.pdp-redesign[data-section-id]');
  if (!roots.length) return;

  roots.forEach((root) => {
    // ---------- Product JSON + variant handling (match theme behavior) ----------
    const productJsonEl = root.querySelector('[data-product-json]');
    let productData = null;
    let currentVariant = null;
    let option1 = null;
    let option2 = null;
    let option3 = null;

    if (productJsonEl) {
      try {
        const jsonData = JSON.parse(productJsonEl.textContent || productJsonEl.innerHTML || '{}');
        productData = jsonData.product || null;
        if (productData && productData.variants) {
          currentVariant =
            productData.variants.find((v) => v.id === jsonData.selected_variant_id) || productData.variants[0] || null;
          option1 = currentVariant ? currentVariant.option1 : null;
          option2 = currentVariant ? currentVariant.option2 : null;
          option3 = currentVariant ? currentVariant.option3 : null;
        }
      } catch (e) {
        productData = null;
      }
    }

    const form = root.querySelector('form.ProductForm');
    const masterSelector = form ? form.querySelector(`#product-select-${productData ? productData.id : ''}`) : null;
    const colourIndex = parseInt(root.getAttribute('data-color-option-index') || '-1', 10);
    const sizeIndex = parseInt(root.getAttribute('data-size-option-index') || '-1', 10);

    function getCurrentVariantFromOptions() {
      if (!productData || !productData.variants) return null;
      return (
        productData.variants.find(
          (v) =>
            (option1 == null || v.option1 === option1) &&
            (option2 == null || v.option2 === option2) &&
            (option3 == null || v.option3 === option3),
        ) || null
      );
    }

    function getSelectedOptionValues() {
      return { 1: option1, 2: option2, 3: option3 };
    }

    function hasVariant(optionValues) {
      if (!productData || !productData.variants) return false;
      return productData.variants.some((variant) => {
        for (let i = 1; i <= 3; i += 1) {
          if (optionValues[i] != null && variant[`option${i}`] !== optionValues[i]) return false;
        }
        return true;
      });
    }

    function setSwatchAvailability(input, isCombinable) {
      if (!input) return;
      const label = input.nextElementSibling;
      const listItem = input.closest('.HorizontalList__Item');
      const isColorSwatch = !!(label && label.classList.contains('ColorSwatchBox'));
      const isSizeSwatch = !!(listItem && listItem.closest('.SizeSwatchList'));

      input.disabled = !isCombinable;

      if (label) {
        label.classList.toggle('is-unavailable', !isCombinable && isColorSwatch);
      }

      if (listItem) {
        listItem.classList.toggle('is-disabled', !isCombinable);
        listItem.classList.toggle('is-unavailable', !isCombinable && isSizeSwatch);
      }
    }

    function updateVariantOptionAvailability() {
      if (!form || !productData || !productData.variants) return;

      const selected = getSelectedOptionValues();
      const colourPos = colourIndex >= 0 ? colourIndex + 1 : -1;
      const sizePos = sizeIndex >= 0 ? sizeIndex + 1 : -1;
      const radios = Array.from(
        form.querySelectorAll('.ProductForm__Option [type="radio"][data-option-position]'),
      );

      radios.forEach((input) => {
        const pos = parseInt(input.getAttribute('data-option-position') || '0', 10);
        if (!pos) return;

        let isCombinable = false;
        if (pos === colourPos) {
          isCombinable = hasVariant({ [pos]: input.value });
        } else if (pos === sizePos) {
          isCombinable = hasVariant({ ...selected, [pos]: input.value });
        } else {
          isCombinable = hasVariant({ ...selected, [pos]: input.value });
        }

        setSwatchAvailability(input, isCombinable);
      });
    }

    function autoSelectExistingSizeForCurrentColour() {
      if (!form || sizeIndex < 0) return false;

      const sizePos = sizeIndex + 1;
      const selected = getSelectedOptionValues();
      const sizeRadios = Array.from(
        form.querySelectorAll(`.SizeSwatch__Radio[data-option-position="${sizePos}"]`),
      );
      if (!sizeRadios.length) return false;

      const currentSizeRadio = sizeRadios.find((radio) => radio.checked);
      if (currentSizeRadio && hasVariant({ ...selected, [sizePos]: currentSizeRadio.value })) {
        return false;
      }

      const nextSizeRadio = sizeRadios.find((radio) =>
        hasVariant({ ...selected, [sizePos]: radio.value }),
      );
      if (!nextSizeRadio) return false;

      nextSizeRadio.checked = true;
      if (sizePos === 1) option1 = nextSizeRadio.value;
      if (sizePos === 2) option2 = nextSizeRadio.value;
      if (sizePos === 3) option3 = nextSizeRadio.value;
      return true;
    }

    function syncVariantIdAttributes(variant) {
      if (!variant || !root) return;
      const nextId = String(variant.id);

      // LensAdvizor "Customise lens / add prescription" CTA — keep its variant id
      // in sync so the popup opens against the currently-selected variant.
      const lensButtons = root.querySelectorAll('lensadvizor-quick-buy[data-la-variant-id]');
      lensButtons.forEach((btn) => {
        if (btn.getAttribute('data-la-variant-id') !== nextId) {
          btn.setAttribute('data-la-variant-id', nextId);
        }
      });

      // Add-to-cart / sold-out / klaviyo-bis CTA — sold-out variants must show the
      // "Notify me" Klaviyo flow keyed off the selected variant id.
      const atcButtons = root.querySelectorAll('.ProductForm__AddToCart[data-variant-id]');
      atcButtons.forEach((btn) => {
        if (btn.getAttribute('data-variant-id') !== nextId) {
          btn.setAttribute('data-variant-id', nextId);
        }
      });

      // Sticky ATC bar (if present) mirrors the same CTA, keep its id in sync too.
      const stickyAtc = document.querySelectorAll('[data-pdp-sticky-bar] [data-variant-id]');
      stickyAtc.forEach((btn) => {
        if (btn.getAttribute('data-variant-id') !== nextId) {
          btn.setAttribute('data-variant-id', nextId);
        }
      });
    }

    function syncAtcAvailability(variant) {
      if (!root) return;
      const atcButtons = root.querySelectorAll('.ProductForm__AddToCart');
      atcButtons.forEach((btn) => {
        const labelSpan = btn.querySelector('span');
        if (!variant) {
          btn.setAttribute('disabled', 'disabled');
          btn.removeAttribute('data-action');
          // Combination doesn't map to a real variant — Klaviyo BIS shouldn't
          // open a notify-me popup for a non-existent variant.
          btn.classList.remove('klaviyo-bis-trigger');
          if (labelSpan && window.languages && window.languages.productFormUnavailable) {
            labelSpan.textContent = window.languages.productFormUnavailable;
          }
          return;
        }
        if (variant.available) {
          btn.removeAttribute('disabled');
          btn.setAttribute('data-action', 'add-to-cart');
          // CRITICAL: when the variant is purchasable, drop the
          // `klaviyo-bis-trigger` class so Klaviyo's global click delegate
          // does NOT open the "Notify me when back in stock" popup on top
          // of our add-to-cart flow.
          btn.classList.remove('klaviyo-bis-trigger');
          if (labelSpan) {
            const ctaText = root.getAttribute('data-secondary-cta-text');
            if (ctaText) {
              labelSpan.textContent = ctaText;
            } else if (window.languages && window.languages.productFormAddToCart) {
              labelSpan.textContent = window.languages.productFormAddToCart;
            }
          }
        } else {
          btn.setAttribute('disabled', 'disabled');
          btn.removeAttribute('data-action');
          // Sold out — re-attach the BIS trigger so clicking opens Klaviyo.
          btn.classList.add('klaviyo-bis-trigger');
          if (labelSpan && window.languages && window.languages.productFormSoldOut) {
            labelSpan.textContent = window.languages.productFormSoldOut;
          }
        }
      });
    }

    // Hide the "Customise lens / add prescription" CTA whenever the selected
    // variant is unavailable (no matching variant) or sold out — there's no
    // purchasable variant to add lenses to in those cases.
    function syncLensSelectorVisibility(variant) {
      if (!root) return;
      const lensButtons = root.querySelectorAll('.pdp-redesign-ctas lensadvizor-quick-buy');
      const isPurchasable = !!(variant && variant.available);
      lensButtons.forEach((btn) => {
        btn.classList.toggle('is-hidden', !isPurchasable);
      });
    }

    /*
     * "Notify me" force-hide.
     *
     * When the variant is available, no third-party "Notify me when back in
     * stock" UI should be visible inside `.pdp-redesign-ctas`. We can't
     * always control where that UI comes from (Klaviyo's script, theme
     * variant handlers, cached DOM from the previous sold-out state, etc.),
     * so we belt-and-braces it:
     *   1. A state class on the `.pdp-redesign-ctas` wrapper (used by CSS)
     *   2. A runtime sweep that hides any *unknown* element inside the CTAs
     *      whose text matches the sold-out / notify-me copy
     *   3. A MutationObserver that re-runs the sweep if anything is injected
     *      after the initial sync.
     */
    const KNOWN_CTA_SELECTOR =
      '.pdp-redesign-primary-cta, .ProductForm__LensSelectorButton, ' +
      'lensadvizor-quick-buy, .pdp-redesign-secondary-cta, .ProductForm__AddToCart';

    function getNotifyMeMatchers() {
      const lang = (typeof window !== 'undefined' && window.languages) || {};
      const candidates = [
        lang.productFormSoldOut,
        lang.productFormUnavailable,
        'notify me',
        'back in stock',
        'sold out',
      ];
      return candidates
        .filter(Boolean)
        .map((s) => String(s).trim().toLowerCase())
        .filter((s) => s.length > 0);
    }

    function forceHideStrayNotifyMe(ctasEl) {
      if (!ctasEl) return;
      const matchers = getNotifyMeMatchers();
      if (matchers.length === 0) return;

      // Walk every element inside the CTAs wrapper. Anything that is NOT
      // one of our known CTAs but whose text mentions notify-me / sold-out
      // is treated as a stray element (Klaviyo embed, leftover button, etc.)
      // and forcefully hidden.
      const all = ctasEl.querySelectorAll('*');
      all.forEach((el) => {
        if (!el || el.nodeType !== 1) return;
        if (typeof el.matches === 'function' && el.matches(KNOWN_CTA_SELECTOR)) return;
        if (typeof el.closest === 'function' && el.closest(KNOWN_CTA_SELECTOR)) return;

        const text = (el.textContent || '').trim().toLowerCase();
        if (!text) return;
        if (text.length > 120) return; // skip large containers
        if (!matchers.some((m) => text.indexOf(m) !== -1)) return;

        el.style.setProperty('display', 'none', 'important');
        el.setAttribute('data-pdp-hidden-by-redesign', 'notify-me');
      });
    }

    function restoreStrayNotifyMe(ctasEl) {
      if (!ctasEl) return;
      const hidden = ctasEl.querySelectorAll('[data-pdp-hidden-by-redesign="notify-me"]');
      hidden.forEach((el) => {
        el.style.removeProperty('display');
        el.removeAttribute('data-pdp-hidden-by-redesign');
      });
    }

    let ctasObserver = null;
    function syncCtasAvailabilityState(variant) {
      if (!root) return;
      const ctas = root.querySelector('.pdp-redesign-ctas');
      if (!ctas) return;

      const isPurchasable = !!(variant && variant.available);
      const isUnavailable = !variant;
      const isSoldOut = !!(variant && !variant.available);

      ctas.classList.toggle('pdp-redesign-ctas--available', isPurchasable);
      ctas.classList.toggle('pdp-redesign-ctas--soldout', isSoldOut);
      ctas.classList.toggle('pdp-redesign-ctas--unavailable', isUnavailable);

      if (isPurchasable) {
        forceHideStrayNotifyMe(ctas);
      } else {
        restoreStrayNotifyMe(ctas);
      }

      // Watch for late DOM mutations — Klaviyo / theme scripts can inject
      // a notify-me element after the initial sync. Re-run the sweep
      // whenever children are added or text changes.
      if (!ctasObserver && typeof MutationObserver !== 'undefined') {
        ctasObserver = new MutationObserver(() => {
          if (ctas.classList.contains('pdp-redesign-ctas--available')) {
            forceHideStrayNotifyMe(ctas);
          }
        });
        ctasObserver.observe(ctas, {
          childList: true,
          subtree: true,
          characterData: true,
        });
      }
    }

    function dispatchVariantChanged(previousVariant, newVariant) {
      if (!form) return;
      syncVariantIdAttributes(newVariant);
      syncAtcAvailability(newVariant);
      syncLensSelectorVisibility(newVariant);
      syncCtasAvailabilityState(newVariant);
      form.dispatchEvent(
        new CustomEvent('variant:changed', {
          bubbles: true,
          detail: { variant: newVariant, previousVariant },
        }),
      );
    }

    function syncOptionUiFromVariant(variant) {
      if (!form) return;

      // When a real variant is found, force the radios to match its options. When
      // the user clicks an "unavailable" option combination (no matching variant),
      // we leave the radio state as-is — the browser already checked the clicked
      // radio — so the active swatch ring and the option label still update.
      if (variant) {
        const optValues = [variant.option1, variant.option2, variant.option3];
        const radios = Array.from(form.querySelectorAll('.ProductForm__Option [type="radio"][data-option-position]'));
        radios.forEach((radio) => {
          const pos = parseInt(radio.getAttribute('data-option-position') || '0', 10);
          if (!pos || pos < 1 || pos > 3) return;
          const wanted = optValues[pos - 1];
          radio.checked = wanted != null && String(radio.value) === String(wanted);
        });
      }

      // Always sync the swatch "selected" ring from the actual `radio.checked`
      // state so the clicked colour stays highlighted even when the variant
      // doesn't exist (admin-disabled / unavailable combinations).
      const swatchRadios = Array.from(form.querySelectorAll('input.ColorSwatch__Radio'));
      swatchRadios.forEach((radio) => {
        const label = radio.nextElementSibling;
        if (label && label.classList) {
          label.classList.toggle('ColorSwatchBox--selected', radio.checked);
        }
      });
    }

    function onOptionRadioChanged(target) {
      if (!target) return;
      const pos = parseInt(target.getAttribute('data-option-position') || '0', 10);
      const value = target.value;
      if (pos === 1) option1 = value;
      if (pos === 2) option2 = value;
      if (pos === 3) option3 = value;

      const colourPos = colourIndex >= 0 ? colourIndex + 1 : -1;
      if (pos === colourPos) {
        autoSelectExistingSizeForCurrentColour();
      }

      const previous = currentVariant;
      currentVariant = getCurrentVariantFromOptions();
      if (currentVariant && masterSelector) {
        masterSelector.value = String(currentVariant.id);
      }
      dispatchVariantChanged(previous, currentVariant);
      syncOptionUiFromVariant(currentVariant);
      updateVariantOptionAvailability();
    }

    if (form) {
      form.addEventListener('change', (e) => {
        const t = e.target;
        if (!(t instanceof HTMLElement)) return;
        if (!t.matches('.ProductForm__Option [type="radio"]')) return;
        onOptionRadioChanged(t);
      });
    }

    const vtoBtn = root.querySelector('[data-pdp-vto]');
    const stickyBar = document.querySelector('[data-pdp-sticky-bar].pdp-sticky-atc-bar');

    // ---------- VTO button offset vs sticky bar ----------
    function syncVtoOffset() {
      if (!vtoBtn) return;
      const stickyVisible = stickyBar && stickyBar.classList.contains('is-visible');
      const baseOffset = 18;
      const isMobile = window.matchMedia('(max-width: 640px)').matches;
      const minStickyHeight = isMobile ? 126 : 0;
      const stickyHeight = stickyBar && stickyBar.offsetHeight ? stickyBar.offsetHeight : 0;
      const safeStickyHeight = Math.max(stickyHeight, minStickyHeight);
      const offset = stickyVisible ? safeStickyHeight + baseOffset : baseOffset;
      root.style.setProperty('--pdp-vto-bottom', `${offset}px`);
    }

    // ---------- Zoom modal ----------
    const zoom = root.querySelector('[data-pdp-zoom]');
    const stage = root.querySelector('[data-pdp-zoom-stage]');
    const zoomImg = root.querySelector('[data-pdp-zoom-img]');
    const zoomThumbs = root.querySelector('[data-pdp-zoom-thumbs]');
    const zoomIndex = root.querySelector('[data-pdp-zoom-index]');
    const zoomTotal = root.querySelector('[data-pdp-zoom-total]');
    const mediaButtons = Array.from(root.querySelectorAll('[data-pdp-media-open]'));
    const mediaSlides = Array.from(root.querySelectorAll('[data-pdp-media-slide]'));
    const mobileSlider = root.querySelector('[data-pdp-mobile-slider]');
    const mobileZoomFab = root.querySelector('[data-pdp-mobile-zoom-fab]');
    const mqMobile = window.matchMedia('(max-width: 640px)');
    const mqMobileGallery = window.matchMedia('(max-width: 768px)');
    let mobileSwiper = null;
    let mobileHiddenSlidesHost = null;

    function getMobileTrack() {
      if (!mobileSlider) return null;
      return mobileSlider.querySelector('.swiper-wrapper');
    }

    function ensureMobileHiddenSlidesHost() {
      if (!mobileSlider) return null;
      if (!mobileHiddenSlidesHost) {
        mobileHiddenSlidesHost = document.createElement('div');
        mobileHiddenSlidesHost.className = 'pdp-redesign-mobile-hidden-slides';
        mobileHiddenSlidesHost.hidden = true;
        mobileSlider.parentElement.appendChild(mobileHiddenSlidesHost);
      }
      return mobileHiddenSlidesHost;
    }

    function mountMobileMediaSlides() {
      const track = getMobileTrack();
      if (!track) return;

      if (!mqMobileGallery.matches) {
        mediaSlides.forEach((slide) => {
          if (slide.parentElement !== track) track.appendChild(slide);
        });
        return;
      }

      const host = ensureMobileHiddenSlidesHost();
      if (!host) return;

      mediaSlides.forEach((slide) => {
        const target = slide.classList.contains('is-hidden') ? host : track;
        if (slide.parentElement !== target) target.appendChild(slide);
      });
    }

    function closeSprieGalleryForNormalImages() {
      const sprieWrapper = root.querySelector('[data-sprie-embed]');
      if (!sprieWrapper || sprieWrapper.classList.contains('is-hidden')) return;
      sprieWrapper.classList.add('is-hidden');
    }

    function isSprieGalleryOpen() {
      const sprieWrapper = root.querySelector('[data-sprie-embed]');
      return !!(sprieWrapper && !sprieWrapper.classList.contains('is-hidden'));
    }

    function getVisibleSlides() {
      return mediaSlides.filter((s) => !s.classList.contains('is-hidden'));
    }

    function getVisibleMediaButtons() {
      return mediaButtons.filter((btn) => {
        const slide = btn.closest('[data-pdp-media-slide]');
        return slide && !slide.classList.contains('is-hidden');
      });
    }

    function getMobileSlideIndex(slide) {
      if (!slide || !mobileSwiper) return -1;
      return Array.from(mobileSwiper.slides).indexOf(slide);
    }

    function refreshMobileSwiperLayout() {
      if (!mobileSwiper) return;
      mobileSwiper.updateSize();
      mobileSwiper.updateSlides();
      mobileSwiper.update();
    }

    function syncMobileGallery(targetSlide, speed = 0) {
      mountMobileMediaSlides();

      if (!mqMobileGallery.matches) return;

      if (!mobileSwiper) {
        initMobileSwiper();
      } else {
        refreshMobileSwiperLayout();
      }

      if (!mobileSwiper) return;

      const slide = targetSlide && !targetSlide.classList.contains('is-hidden')
        ? targetSlide
        : getVisibleSlides()[0];
      if (!slide) {
        syncMobileThumbActive();
        return;
      }

      const slideIndex = getMobileSlideIndex(slide);
      if (slideIndex < 0) {
        syncMobileThumbActive();
        return;
      }

      mobileSwiper.slideTo(slideIndex, speed);
      syncMobileThumbActive();
    }

    function goToMobileMediaSlide(slide, speed = 400) {
      if (!slide || slide.classList.contains('is-hidden')) return false;
      syncMobileGallery(slide, speed);
      return true;
    }

    function getActiveMobileSlide() {
      if (mobileSwiper && mobileSwiper.slides && mobileSwiper.slides.length) {
        const current = mobileSwiper.slides[mobileSwiper.activeIndex] || null;
        if (current && !current.classList.contains('is-hidden')) {
          return current;
        }
      }
      return getVisibleSlides()[0] || null;
    }

    // ---------- Video autoplay; pause state is tracked per media slide ----------
    const userPausedMediaKeys = new Set();
    let isSyncingPlayback = false;

    function getVideoMediaKey(video) {
      const slide = video.closest('[data-pdp-media-slide]');
      if (!slide) return null;
      const position = slide.getAttribute('data-media-position');
      return position != null && position !== '' ? position : null;
    }

    function isVideoUserPaused(video) {
      const key = getVideoMediaKey(video);
      return key != null && userPausedMediaKeys.has(key);
    }

    function getPdpVideos() {
      return Array.from(root.querySelectorAll('.pdp-redesign-media-video'));
    }

    function getVisiblePdpVideos() {
      return getPdpVideos().filter((video) => {
        const slide = video.closest('[data-pdp-media-slide]');
        return slide && !slide.classList.contains('is-hidden');
      });
    }

    function getPrimaryPlaybackVideo() {
      const visibleVideos = getVisiblePdpVideos();
      if (!visibleVideos.length) return null;

      if (mqMobileGallery.matches) {
        const activeSlide = getActiveMobileSlide();
        if (activeSlide) {
          const activeVideo = activeSlide.querySelector('.pdp-redesign-media-video');
          if (activeVideo && visibleVideos.includes(activeVideo)) return activeVideo;
        }
      }

      return visibleVideos[0];
    }

    function isUserPauseEvent(event, video) {
      if (!event || !event.isTrusted) return false;
      if (isSyncingPlayback) return false;

      const slide = video.closest('[data-pdp-media-slide]');
      if (!slide || slide.classList.contains('is-hidden')) return false;

      return true;
    }

    function bindVideoPlaybackListeners() {
      getPdpVideos().forEach((video) => {
        if (video.dataset.pdpVideoBound === 'true') return;
        video.dataset.pdpVideoBound = 'true';

        video.addEventListener('pause', (e) => {
          if (!isUserPauseEvent(e, video)) return;
          const key = getVideoMediaKey(video);
          if (key) userPausedMediaKeys.add(key);
        });

        video.addEventListener('play', (e) => {
          if (!e.isTrusted || isSyncingPlayback) return;
          const key = getVideoMediaKey(video);
          if (key) userPausedMediaKeys.delete(key);
        });
      });
    }

    function endSyncingPlayback() {
      window.setTimeout(() => {
        isSyncingPlayback = false;
      }, 0);
    }

    function syncVideoPlayback() {
      const mobilePrimaryVideo = mqMobileGallery.matches ? getPrimaryPlaybackVideo() : null;

      isSyncingPlayback = true;
      getPdpVideos().forEach((video) => {
        const slide = video.closest('[data-pdp-media-slide]');
        const isHidden = !slide || slide.classList.contains('is-hidden');
        let shouldPlay = !isHidden && !isVideoUserPaused(video);
        if (mqMobileGallery.matches) {
          shouldPlay = shouldPlay && video === mobilePrimaryVideo;
        }

        if (shouldPlay) {
          if (video.paused) {
            const playPromise = video.play();
            if (playPromise && typeof playPromise.catch === 'function') {
              playPromise.catch(() => {});
            }
          }
          return;
        }

        if (!video.paused) {
          video.pause();
        }
      });
      endSyncingPlayback();
    }

    function destroyMobileSwiper() {
      if (!mobileSwiper) return;
      mobileSwiper.destroy(true, true);
      mobileSwiper = null;
    }

    function initMobileSwiper() {
      if (!mobileSlider) return;

      mountMobileMediaSlides();

      if (!mqMobileGallery.matches) {
        destroyMobileSwiper();
        return;
      }

      if (typeof Swiper === 'undefined') {
        window.setTimeout(initMobileSwiper, 100);
        return;
      }

      if (mobileSlider.swiper) {
        mobileSwiper = mobileSlider.swiper;
        mobileSwiper.update();
        syncMobileThumbActive();
        syncVideoPlayback();
        return;
      }

      mobileSwiper = new Swiper(mobileSlider, {
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 400,
        threshold: 8,
        touchStartPreventDefault: false,
        touchMoveStopPropagation: false,
        passiveListeners: true,
        nested: true,
        watchOverflow: true,
        resistanceRatio: 0.85,
        noSwipingClass: 'swiper-no-swiping',
        on: {
          init: () => {
            syncMobileThumbActive();
            syncVideoPlayback();
          },
          slideChange: () => {
            closeSprieGalleryForNormalImages();
            syncMobileThumbActive();
            syncVideoPlayback();
          },
        },
      });
    }

    function syncMobileThumbActive(options = {}) {
      if (!mqMobileGallery.matches) return;
      const thumbs = Array.from(root.querySelectorAll('[data-pdp-mobile-thumb]'));
      const activeSlide = options.alignToFirstVisible ? getVisibleSlides()[0] : getActiveMobileSlide();
      if (!activeSlide) {
        thumbs.forEach((t) => {
          if (!t.classList.contains('is-hidden')) t.classList.remove('is-active');
        });
        return;
      }

      const activePos = activeSlide.getAttribute('data-media-position');
      thumbs.forEach((t) => {
        if (t.classList.contains('is-hidden')) return;
        t.classList.toggle('is-active', t.getAttribute('data-media-position') === activePos);
      });
    }

    initMobileSwiper();
    bindVideoPlaybackListeners();
    syncVideoPlayback();

    root.querySelectorAll('[data-pdp-mobile-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (thumb.classList.contains('is-hidden')) return;
        closeSprieGalleryForNormalImages();
        const pos = thumb.getAttribute('data-media-position');
        const slide = mediaSlides.find(
          (s) => s.getAttribute('data-media-position') === pos && !s.classList.contains('is-hidden'),
        );
        if (!slide) return;
        if (mobileSwiper) {
          goToMobileMediaSlide(slide);
          syncVideoPlayback();
          return;
        }
        if (!mobileSlider) return;
        mobileSlider.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        window.setTimeout(syncMobileThumbActive, 280);
      });
    });

    if (mobileZoomFab) {
      mobileZoomFab.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!mqMobileGallery.matches) return;
        const visibleBtns = getVisibleMediaButtons();
        const activeSlide = getActiveMobileSlide();
        if (!visibleBtns.length || !activeSlide) return;

        const matchBtn = visibleBtns.find(
          (btn) => btn.closest('[data-pdp-media-slide]') === activeSlide,
        );
        (matchBtn || visibleBtns[0]).click();
      });
    }

    function buildZoomItemsFromButtons(buttons) {
      return buttons
        .map((btn) => {
          const img = btn.querySelector('img');
          const src =
            btn.getAttribute('data-zoom-src') ||
            (img ? img.getAttribute('data-original-src') : null) ||
            (img ? img.currentSrc : null) ||
            (img ? img.getAttribute('src') : null);
          const thumb = img ? img.getAttribute('src') : null;
          return src ? { src, thumb } : null;
        })
        .filter(Boolean);
    }

    let zoomItems = buildZoomItemsFromButtons(getVisibleMediaButtons());

    let currentIndex = 0;

    function renderZoomThumbs() {
      if (!zoomThumbs) return;
      zoomThumbs.innerHTML = '';
      zoomItems.forEach((item, idx) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', `Image ${idx + 1}`);
        b.dataset.pdpZoomThumb = 'true';
        b.addEventListener('click', () => showZoomAt(idx));
        const im = document.createElement('img');
        im.src = item.thumb || item.src;
        im.alt = '';
        b.appendChild(im);
        zoomThumbs.appendChild(b);
      });
    }

    function showZoomAt(idx) {
      if (!zoomItems.length) return;
      currentIndex = (idx + zoomItems.length) % zoomItems.length;
      if (zoomImg) zoomImg.src = zoomItems[currentIndex].src;
      if (zoomIndex) zoomIndex.textContent = String(currentIndex + 1);
      if (zoomTotal) zoomTotal.textContent = String(zoomItems.length);
      if (stage) stage.classList.remove('is-zoomed');
      if (zoomImg) {
        zoomImg.style.setProperty('--pdp-pan-x', '0px');
        zoomImg.style.setProperty('--pdp-pan-y', '0px');
        zoomImg.style.setProperty('--pdp-zoom-scale', '1');
      }
      if (zoomThumbs) {
        Array.from(zoomThumbs.querySelectorAll('button[data-pdp-zoom-thumb]')).forEach((btn, i) => {
          btn.classList.toggle('is-active', i === currentIndex);
        });
      }
    }

    function openZoom(idx) {
      if (!zoom) return;
      zoomItems = buildZoomItemsFromButtons(getVisibleMediaButtons());
      zoom.hidden = false;
      document.documentElement.classList.add('pdp-redesign-zoomopen');
      document.body.classList.add('pdp-redesign-zoomopen');
      renderZoomThumbs();
      showZoomAt(idx || 0);
    }

    function closeZoom() {
      if (!zoom) return;
      zoom.hidden = true;
      if (stage) stage.classList.remove('is-zoomed');
      document.documentElement.classList.remove('pdp-redesign-zoomopen');
      document.body.classList.remove('pdp-redesign-zoomopen');
      if (zoomImg) {
        zoomImg.style.setProperty('--pdp-pan-x', '0px');
        zoomImg.style.setProperty('--pdp-pan-y', '0px');
        zoomImg.style.setProperty('--pdp-zoom-scale', '1');
      }
    }

    mediaButtons.forEach((btn) =>
      btn.addEventListener('click', () => {
        const visibleButtons = getVisibleMediaButtons();
        const idx = visibleButtons.indexOf(btn);
        openZoom(Math.max(0, idx));
      }),
    );
    root.querySelectorAll('[data-pdp-zoom-close]').forEach((el) => el.addEventListener('click', closeZoom));
    root.querySelector('[data-pdp-zoom-prev]')?.addEventListener('click', (e) => {
      e.stopPropagation();
      showZoomAt(currentIndex - 1);
    });
    root.querySelector('[data-pdp-zoom-next]')?.addEventListener('click', (e) => {
      e.stopPropagation();
      showZoomAt(currentIndex + 1);
    });
    // Zoom-in on single click, then pan on pointer move (no toggle back).
    if (stage && zoomImg) {
      let panRafId = 0;
      let targetX = 0;
      let targetY = 0;
      let currentX = 0;
      let currentY = 0;

      const startPanLoop = () => {
        if (panRafId) return;
        const tick = () => {
          if (!stage || !zoomImg || !stage.classList.contains('is-zoomed') || !zoom || zoom.hidden) {
            panRafId = 0;
            return;
          }

          // Smooth interpolation to remove "jerk"
          const ease = 0.14;
          currentX += (targetX - currentX) * ease;
          currentY += (targetY - currentY) * ease;
          zoomImg.style.setProperty('--pdp-pan-x', `${currentX.toFixed(2)}px`);
          zoomImg.style.setProperty('--pdp-pan-y', `${currentY.toFixed(2)}px`);
          panRafId = window.requestAnimationFrame(tick);
        };

        panRafId = window.requestAnimationFrame(tick);
      };

      stage.addEventListener('click', (e) => {
        if (e.target && e.target.closest && e.target.closest('.pdp-redesign-zoom-arrow')) return;
        const isZoomed = stage.classList.contains('is-zoomed');

        if (!isZoomed) {
          stage.classList.add('is-zoomed');
          zoomImg.style.setProperty('--pdp-zoom-scale', '2.5');
          targetX = 0;
          targetY = 0;
          currentX = 0;
          currentY = 0;
          zoomImg.style.setProperty('--pdp-pan-x', '0px');
          zoomImg.style.setProperty('--pdp-pan-y', '0px');
          startPanLoop();
          return;
        }

        // Toggle back to original size on next click
        stage.classList.remove('is-zoomed');
        zoomImg.style.setProperty('--pdp-zoom-scale', '1');
        targetX = 0;
        targetY = 0;
        currentX = 0;
        currentY = 0;
        zoomImg.style.setProperty('--pdp-pan-x', '0px');
        zoomImg.style.setProperty('--pdp-pan-y', '0px');
        if (panRafId) {
          window.cancelAnimationFrame(panRafId);
          panRafId = 0;
        }
      });

      const onMove = (e) => {
        if (!stage || !zoomImg || !stage.classList.contains('is-zoomed')) return;
        const rect = stage.getBoundingClientRect();
        const x = Math.min(1, Math.max(0, (e.clientX - rect.left) / rect.width));
        const y = Math.min(1, Math.max(0, (e.clientY - rect.top) / rect.height));

        // Pan range (pixels) tuned to match reference feel
        const panMaxX = 220;
        const panMaxY = 140;
        targetX = (0.5 - x) * 2 * panMaxX;
        targetY = (0.5 - y) * 2 * panMaxY;
      };

      stage.addEventListener('mousemove', onMove);
      stage.addEventListener('touchmove', (e) => {
        if (!e.touches || !e.touches[0]) return;
        onMove(e.touches[0]);
      }, { passive: true });
    }

    document.addEventListener('keydown', (e) => {
      if (!zoom || zoom.hidden) return;
      if (e.key === 'Escape') closeZoom();
      if (e.key === 'ArrowLeft') showZoomAt(currentIndex - 1);
      if (e.key === 'ArrowRight') showZoomAt(currentIndex + 1);
    });

     
    if (form) {
      form.addEventListener('click', (event) => {
        let button = null;

        // Prefer `composedPath()` because the inner <span> may already be
        // detached from the DOM by custom.js's capture-phase loading-label sync.
        if (typeof event.composedPath === 'function') {
          const path = event.composedPath();
          for (let i = 0; i < path.length; i += 1) {
            const node = path[i];
            if (
              node &&
              node.nodeType === 1 &&
              typeof node.matches === 'function' &&
              node.matches('.ProductForm__AddToCart[data-action="add-to-cart"]')
            ) {
              button = node;
              break;
            }
          }
        }

        // Fallback for the rare case `composedPath` is unavailable and the
        // target still happens to be attached.
        if (!button && event.target && typeof event.target.closest === 'function') {
          button = event.target.closest('.ProductForm__AddToCart[data-action="add-to-cart"]');
        }

        if (!button || button.disabled) return;
        if (!currentVariant || !currentVariant.available) return;

        event.preventDefault();

        const qtyInput = form.querySelector('[name="quantity"]');
        const parsedQty = qtyInput ? parseInt(qtyInput.value || '1', 10) : 1;
        const quantity = Number.isFinite(parsedQty) && parsedQty > 0 ? parsedQty : 1;
        const payload = { id: currentVariant.id, quantity };

        button.setAttribute('disabled', 'disabled');
        document.dispatchEvent(new CustomEvent('theme:loading:start'));

        const rootUrl = (window.theme && window.theme.localeRootUrl) ? window.theme.localeRootUrl : '';

        fetch(rootUrl + '/cart/add.js', {
          body: JSON.stringify(payload),
          credentials: 'same-origin',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
        })
          .then((response) => {
            document.dispatchEvent(new CustomEvent('theme:loading:end'));
            button.removeAttribute('disabled');
            if (!response.ok) return null;
            return response.json().catch(() => null);
          })
          .then((cartItem) => {
            if (cartItem === null) return;
            form.dispatchEvent(
              new CustomEvent('product:added', {
                bubbles: true,
                detail: { variant: currentVariant, quantity: payload.quantity },
              }),
            );
          })
          .catch(() => {
            document.dispatchEvent(new CustomEvent('theme:loading:end'));
            button.removeAttribute('disabled');
          });
      });
    }

    // Keep colour + size labels in sync with current variant selection
    const colourLabel = root.querySelector('[data-pdp-selected-colour]');
    const sizeLabel = root.querySelector('[data-pdp-selected-size]');
    const rangesEl = root.querySelector('[data-pdp-colour-media-ranges]');
    const sharedMediaEl = root.querySelector('[data-pdp-shared-media-positions]');
    let colourRanges = null;
    let sharedMediaPositions = [];
    if (rangesEl) {
      try {
        colourRanges = JSON.parse(rangesEl.textContent || '{}');
      } catch (e) {
        colourRanges = null;
      }
    }
    if (sharedMediaEl) {
      try {
        const parsed = JSON.parse(sharedMediaEl.textContent || '[]');
        sharedMediaPositions = Array.isArray(parsed)
          ? parsed.map((p) => Number(p)).filter((p) => Number.isFinite(p))
          : [];
      } catch (e) {
        sharedMediaPositions = [];
      }
    }

    function updateColourLabelFromVariant(variant) {
      if (!colourLabel || !variant || colourIndex < 0) return;
      const optKey = `option${colourIndex + 1}`;
      if (variant[optKey]) colourLabel.textContent = variant[optKey];
    }

    function updateSizeLabelFromVariant(variant) {
      if (!sizeLabel || !variant || sizeIndex < 0) return;
      const optKey = `option${sizeIndex + 1}`;
      if (variant[optKey]) sizeLabel.textContent = variant[optKey];
    }

    function applyMediaFilterForColour(colourValue) {
      const slides = mediaSlides;
      const thumbs = Array.from(root.querySelectorAll('[data-pdp-mobile-thumb]'));
      if (!slides.length) return;

      function applyLayoutPattern() {
        const visibleSlides = slides.filter((s) => !s.classList.contains('is-hidden'));
        visibleSlides.forEach((slide, idx) => {
          slide.classList.remove('pdp-redesign-media-slide--full', 'pdp-redesign-media-slide--half');
          if (visibleSlides.length <= 2) {
            slide.classList.add('pdp-redesign-media-slide--full');
            return;
          }
          let isFull = idx === 0 || idx % 3 === 0;
          if (!isFull && idx === visibleSlides.length - 1) {
            const prevIdx = idx - 1;
            if (prevIdx === 0 || prevIdx % 3 === 0) isFull = true;
          }
          slide.classList.add(isFull ? 'pdp-redesign-media-slide--full' : 'pdp-redesign-media-slide--half');
        });
      }

      function syncSpinVisibility() {
        const spinBtns = Array.from(root.querySelectorAll('.pdp-redesign-spin360'));
        if (!spinBtns.length) return;
        spinBtns.forEach((spinBtn) => {
          const hostSlide = spinBtn.closest('[data-pdp-media-slide]');
          if (!hostSlide) return;
          spinBtn.classList.toggle('is-hidden', hostSlide.classList.contains('is-hidden'));
        });
      }

      let useRange = Boolean(colourRanges && colourValue && colourRanges[colourValue]);
      if (useRange) {
        const range = colourRanges[colourValue];
        const start = Number(range.start);
        const end = Number(range.end);
        if (!Number.isFinite(start) || !Number.isFinite(end) || start === end) {
          useRange = false;
        }
      }

      if (!useRange) {
        slides.forEach((s) => s.classList.remove('is-hidden'));
        thumbs.forEach((t) => t.classList.remove('is-hidden'));
      } else {
        const range = colourRanges[colourValue];
        const start = Number(range.start);
        const end = Number(range.end);
        const posInRange = (pos) => {
          if (sharedMediaPositions.includes(pos)) return true;
          return start < end ? pos >= start && pos < end : pos >= start || pos < end;
        };

        slides.forEach((slide) => {
          const pos = Number(slide.getAttribute('data-media-position'));
          if (!Number.isFinite(pos)) {
            slide.classList.remove('is-hidden');
            return;
          }
          slide.classList.toggle('is-hidden', !posInRange(pos));
        });

        thumbs.forEach((thumb) => {
          const pos = Number(thumb.getAttribute('data-media-position'));
          if (!Number.isFinite(pos)) {
            thumb.classList.remove('is-hidden');
            return;
          }
          thumb.classList.toggle('is-hidden', !posInRange(pos));
        });
      }

      applyLayoutPattern();
      syncSpinVisibility();
      if (!isSprieGalleryOpen()) {
        syncMobileGallery(getVisibleSlides()[0], 0);
        syncVideoPlayback();
        return;
      }

      mountMobileMediaSlides();
      if (mobileSwiper) refreshMobileSwiperLayout();
      syncMobileThumbActive({ alignToFirstVisible: true });
      syncVideoPlayback();
    }

    function getColourValueFromVariant(variant) {
      if (!variant || colourIndex < 0) return null;
      const optKey = `option${colourIndex + 1}`;
      return variant[optKey] || null;
    }

    // Read whichever of option1/2/3 corresponds to the given option index
    // (so we can update the colour-name label and filter media even when the
    // selected combination is unavailable and `currentVariant` is null).
    function getCurrentOptionValueByIndex(index) {
      if (index < 0) return null;
      if (index === 0) return option1;
      if (index === 1) return option2;
      if (index === 2) return option3;
      return null;
    }

    document.addEventListener('variant:changed', (event) => {
      const variant = event.detail && event.detail.variant ? event.detail.variant : null;

      if (variant) {
        updateColourLabelFromVariant(variant);
        updateSizeLabelFromVariant(variant);
        applyMediaFilterForColour(getColourValueFromVariant(variant));
      } else {
        // Unavailable option combination — fall back to the option values the
        // user just clicked. The colour name + image filter must still react,
        // even though no purchasable variant exists for this combination.
        const colourValue = getCurrentOptionValueByIndex(colourIndex);
        const sizeValue = getCurrentOptionValueByIndex(sizeIndex);
        if (colourLabel && colourValue) colourLabel.textContent = colourValue;
        if (sizeLabel && sizeValue) sizeLabel.textContent = sizeValue;
        if (colourValue) applyMediaFilterForColour(colourValue);
      }

      syncOptionUiFromVariant(variant);
      updateVariantOptionAvailability();
    });

    // ---------- Init & observers ----------
    const onScroll = () => {
      syncVtoOffset();
    };

    syncVtoOffset();
    if (colourLabel) applyMediaFilterForColour(colourLabel.textContent);
    if (currentVariant) {
      updateColourLabelFromVariant(currentVariant);
      updateSizeLabelFromVariant(currentVariant);
      syncOptionUiFromVariant(currentVariant);
      syncVariantIdAttributes(currentVariant);
      syncAtcAvailability(currentVariant);
    }
    syncLensSelectorVisibility(currentVariant);
    syncCtasAvailabilityState(currentVariant);
    updateVariantOptionAvailability();
    syncMobileThumbActive();

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', () => {
      syncVtoOffset();
      mountMobileMediaSlides();
      initMobileSwiper();
      syncMobileThumbActive();
      syncVideoPlayback();
    });

    if (stickyBar && typeof MutationObserver !== 'undefined') {
      const obs = new MutationObserver(syncVtoOffset);
      obs.observe(stickyBar, { attributes: true, attributeFilter: ['class'] });
    }
  });
})();

